import { css } from 'lit';

export const pageContentStyles = css`
  .page {
    min-height: 60vh;
  }
  .page__header {
    padding: var(--space-20, 5rem) var(--content-padding, 2rem) var(--space-12, 3rem);
    max-width: var(--content-max-width, 1440px);
    margin: 0 auto;
    text-align: center;
  }
  .page__title {
    margin: 0 0 var(--space-4, 1rem);
    font-size: var(--text-4xl, 2.5rem);
    font-weight: var(--font-extrabold, 800);
    line-height: var(--leading-tight, 1.1);
  }
  .page__subtitle {
    max-width: 720px;
    margin: 0 auto;
    color: var(--color-text-secondary, #a0a0b8);
    font-size: var(--text-lg, 1.125rem);
    line-height: var(--leading-relaxed, 1.7);
  }
  .elements {
    display: grid;
    gap: var(--space-12, 3rem);
    padding: 0 var(--content-padding, 2rem) var(--space-20, 5rem);
    max-width: var(--content-max-width, 1440px);
    margin: 0 auto;
  }
  .elements--flush {
    max-width: none;
    padding: 0 0 var(--space-20, 5rem);
  }
  .text {
    max-width: 850px;
    margin: 0 auto;
    color: var(--color-text-secondary, #a0a0b8);
    line-height: var(--leading-relaxed, 1.7);
  }
  .text h1, .text h2, .text h3, .text h4 {
    color: var(--color-text-primary, #f0f0f5);
    margin: 0;
  }
  .text--center {
    text-align: center;
  }
  .text--right {
    text-align: right;
  }
  .rich {
    max-width: 850px;
    margin: 0 auto;
    color: var(--color-text-secondary, #a0a0b8);
    line-height: var(--leading-relaxed, 1.7);
  }
  .rich img, .image img {
    display: block;
    width: 100%;
    border-radius: var(--border-radius, 0.75rem);
  }
  .image {
    max-width: 960px;
    margin: 0 auto;
  }
  .image figcaption {
    margin-top: var(--space-3, 0.75rem);
    color: var(--color-text-muted, #6b6b80);
    text-align: center;
    font-size: var(--text-sm, 0.875rem);
  }
  .grid {
    display: grid;
    gap: var(--space-6, 1.5rem);
    grid-template-columns: repeat(var(--columns, 3), minmax(0, 1fr));
  }
  .grid__item {
    min-width: 0;
  }
  .grid__image {
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    border-radius: var(--border-radius, 0.75rem);
    margin-bottom: var(--space-4, 1rem);
  }
  .grid__link, .button {
    display: inline-flex;
    width: fit-content;
    align-items: center;
    justify-content: center;
    min-height: 2.75rem;
    padding: 0 var(--space-5, 1.25rem);
    border-radius: var(--border-radius-sm, 0.375rem);
    text-decoration: none;
    font-weight: var(--font-semibold, 600);
    background: var(--color-cta, #ff6b35);
    color: white;
  }
  .button--secondary {
    background: transparent;
    color: var(--color-accent, #00d4ff);
    border: 1px solid var(--color-accent, #00d4ff);
  }
  .container, .row, .columns {
    display: grid;
    gap: var(--space-8, 2rem);
  }
  .container--hero {
    padding-top: var(--space-16, 4rem);
    padding-bottom: var(--space-16, 4rem);
  }
  .container--narrow {
    max-width: 900px;
    margin: 0 auto;
  }
  .row {
    grid-auto-flow: column;
    grid-auto-columns: minmax(0, 1fr);
    align-items: start;
  }
  .columns {
    grid-template-columns: repeat(var(--columns, 2), minmax(0, 1fr));
  }
  @media (max-width: 768px) {
    .row, .columns {
      grid-auto-flow: row;
      grid-template-columns: 1fr;
    }
    .grid {
      grid-template-columns: 1fr;
    }
    .page__title {
      font-size: var(--text-3xl, 2rem);
    }
  }
`;
